import React, { Fragment, useState } from "react";
import "../../templateform/templateform.css";
import Accordion from "react-bootstrap/Accordion";
import { Button, Form } from 'react-bootstrap';

function About(props) {
  const { setFormDetail, formDetail, defaultFormDetail, languageData } = props;
  const [isAccordionOpen, setIsAccordionOpen] = useState(formDetail?.aboutus?.status || false);
  const [error, setError] = useState("");


  const handleToggle = (e) => {
    e.stopPropagation(); // Prevent the Accordion from toggling
    setIsAccordionOpen(!isAccordionOpen);
    setFormDetail({
      ...formDetail,
      aboutus: { ...formDetail.aboutus, status: !isAccordionOpen }
    });
  };

  const handleInput = (e) => {
    const { name, value } = e.target;

    // Check if the character limit is exceeded
    if (value.length > 2000) {
      setError("You have exceeded your word limit");
      return; // Stop further updates if limit is reached
    } else {
      setError(""); // Clear the error if within limit
    }

    setFormDetail({
      ...formDetail,
      [name]: { ...formDetail[name], value: value }
    });
  };
  const handleReset = (e) => {
    setFormDetail({
      ...formDetail,
      ['aboutus']: { ...formDetail['aboutus'], value: defaultFormDetail?.aboutus?.value }
    });
  };

  return (
    <Fragment>
      <Accordion defaultActiveKey={isAccordionOpen ? "0" : ""}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="drop_header_dflex">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src="/assets/images/icon/info.png" width={'20%'} alt="About" /> {" "}  <span style={{ marginLeft: '15px' }}>{languageData?.about}</span>
              </div>
              <div style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
              >
                {/* <Form.Check
                  style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
                  type="switch"
                  defaultChecked={isAccordionOpen}
                  onChange={handleToggle}
                  className="custom-switch"
                  onClick={(e) => e.stopPropagation()} // Prevent event bubbling
                /> */}

                <label className="custom-toggle-ios m-1" onClick={(e) => e.stopPropagation()} >
                  <input
                    type="checkbox"
                    checked={isAccordionOpen}
                    onChange={handleToggle}
                  />
                  <span className="slider-ios">{isAccordionOpen ? 'Show' : 'Hide'}</span>
                </label>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Collapse eventKey="0">
            <Accordion.Body>
              <div className="row">
                {/* <div className="col-lg-12">
                  <div className="heading_lable_box">
                    <label className="forn_title">{languageData?.heading} :</label>
                  </div>
                  <input type="text" className="form-control" style={{ width: 'auto' }} />
                </div> */}
                <div className="col-lg-12 mt-3">
                  <div className="input-field-box">
                    <div className="heading_lable_box">
                      <label className="forn_title">{languageData?.aboutDescription} :</label>
                    </div>
                    <textarea
                      placeholder="Enter Description ..."
                      className="form-control pb-5 my-2"
                      name="aboutus"
                      onChange={handleInput}
                      value={formDetail.aboutus.value || ""}
                    />
                  </div>
                  {error && (
                    <p className="text-danger text-end error-line">{error}</p>
                  )}
                </div>
              </div>
              <Button
                onClick={() => handleReset()}
                style={{ borderRadius: 50, width: 100, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                size='md'

              >
                {languageData?.reset}
              </Button>
            </Accordion.Body>
          </Accordion.Collapse>
        </Accordion.Item>
      </Accordion>
    </Fragment>
  );
}

export default About;
